// Prevent an event from doing any native behavior (like following anchor clicks).
export function thouShallNotPass(e: Event) {
  e.preventDefault();
  e.stopImmediatePropagation();
  e.stopPropagation();
}
